import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGiveIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M12.75 8.5C12.5 9.25 11.8399 9.75 11 9.75C9.5 9.75 8.75 8 8.75 6C8.75 4 9.5 2.25 11 2.25C11.8399 2.25 12.5 2.75 12.75 3.5M7.75 4.75H10.25M7.75 7.25H10.25" }), /* @__PURE__ */ _jsx("path", {
		d: "M9.56703 14.561L14.4715 12.9262C14.7871 12.821 15 12.5256 15 12.1929C15 11.7051 14.5537 11.3393 14.0754 11.4349L10 12.25L6.80361 9.99377C6.13091 9.51893 5.29263 9.34146 4.48522 9.50295L2.40194 9.91961C2.16823 9.96635 2 10.1716 2 10.4099V12.5C2 12.7761 2.22386 13 2.5 13L4.80622 13C5.09847 13 5.38716 13.064 5.65199 13.1876L8.45837 14.4972C8.80616 14.6595 9.20293 14.6824 9.56703 14.561Z",
		stroke: "none",
		fill: "currentColor"
	})]
});
export default SvgGiveIcon;
